import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-references-subcard-info',
    templateUrl: './references-subcard-info.component.html',
    styleUrls: ['./references-subcard-info.component.scss'],
    standalone: false
})
export class ReferencesSubcardInfoComponent implements OnInit {
  @Input() referenceData:any;
  constructor() { }

  ngOnInit(): void {
  }

}
